interface LoginSuccessData {
  redirectUrl: string;
}
export function useLoginSuccess(): ({ redirectUrl }: LoginSuccessData) => void {
  return ({ redirectUrl }: LoginSuccessData) => {
    localStorage.removeItem('authData');
    window.location.assign(redirectUrl);
  };
}
